import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../config/queryClient';
import { apiService } from '../services/apiService';
import { OwnershipScope } from '../types/favourites';
import { getEventsCalendarRange } from '../utils/eventsCalendarRange';

export function useEventsCalendar(
  includeWarrants: boolean = true,
  ownershipScope: OwnershipScope = 'group'
) {
  const range = getEventsCalendarRange();

  const query = useQuery({
    queryKey: queryKeys.events.calendar(
      range.fromDate,
      range.toDate,
      includeWarrants,
      ownershipScope
    ),
    queryFn: () =>
      apiService.getEventsCalendar(
        range.fromDate,
        range.toDate,
        includeWarrants,
        ownershipScope
      ),
  });

  return {
    days: query.data ?? [],
    range,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
    isFetching: query.isFetching,
  };
}
